import { ReportPermissions } from '@sr/dto';
import { ErrorBanner } from 'shared/ui/error-banner';
import { Box, Stack } from '@mui/material';
import { useStateSelector } from 'shared/store';
import { TopManangerPeriodPicker } from 'entities/reports/top-manager/top-manager-period/top-manager-period-picker';
import { TopManagerGrid } from 'entities/reports/top-manager/top-manager-grid';

export const TopManager = () => {
  const canView = useStateSelector((state) => state.auth.user?.permissions.includes(ReportPermissions.VIEW_TOP_MANAGER));
  const selectedPeriod = useStateSelector((state) => state.topManagerSelectedPeriod.value);
  if (!canView) return <ErrorBanner errorMessage="У вас нет разрешения на просмотр отчета «Топ менеджер»" />;

  return (
    <>
      <Stack sx={{ gap: 1, display: 'flex', flexDirection: 'row', alignItems: 'center', '& .MuiInputBase-root': { backgroundColor: '#fff' } }}>
        <Box sx={{ minWidth: 200, maxWidth: 308, mb: 1 }}>
          <TopManangerPeriodPicker />
        </Box>
      </Stack>
      <TopManagerGrid year={selectedPeriod.year} month={selectedPeriod.month} />   
    </>
  );
};
